






































import Vue from 'vue';
import HumanizeTime from '../date/HumanizeTime.vue';

export default Vue.extend({
  components: { HumanizeTime },
  props: {
    saving: {
      type: Boolean,
      default: false,
    },
    lastSave: String,
    lastSaveText: {
      type: String,
      default: 'Saved',
    },
    error: String,
  },
});
